// extracted by mini-css-extract-plugin
export default {"section":"QuickActionsSection_section__MFMFd","title":"QuickActionsSection_title__5xn70","cardGrid":"QuickActionsSection_cardGrid__l+Gcg"};